var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-visibility__wrapper t-margin-bottom-s" },
    [
      _vm.type === "Process"
        ? [
            _vm.status === "Unpublished"
              ? _c("div", [
                  _c("p", [
                    _c(
                      "span",
                      {
                        staticClass: "c-icon c-icon--28px",
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("svg", [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-closed-eye" }
                          })
                        ])
                      ]
                    ),
                    _vm._v(
                      "\n\t\t\t\t\tJust nu ser bara du processen\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-visibility__action" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "c-button c-button--reset c-button--linkstyle",
                        attrs: { type: "submit" },
                        on: { click: _vm.toggleStatusModal }
                      },
                      [_vm._v("Publicera process")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.status === "Published"
              ? _c("div", [
                  _c("p", [
                    _c(
                      "span",
                      {
                        staticClass: "c-icon c-icon--28px",
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("svg", [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-open-eye" }
                          })
                        ])
                      ]
                    ),
                    _vm._v("\n\t\t\t\t\tJust nu ser alla processen\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-visibility__action" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "c-button c-button--reset c-button--linkstyle",
                        attrs: { type: "submit" },
                        on: { click: _vm.toggleStatusModal }
                      },
                      [_vm._v("Avpublicera process")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "modal",
              {
                attrs: { show: _vm.showStatusModal },
                on: { closeModal: _vm.toggleStatusModal }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "c-modal__content t-background-white t-text-align-center"
                  },
                  [
                    _vm.status === "Unpublished"
                      ? [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "t-text-style-alpha t-margin-bottom-s"
                            },
                            [_vm._v("Du publicerar nu process")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                              on: { click: _vm.toggleStatusModal }
                            },
                            [_vm._v("Avbryt")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "c-button c-button--primary",
                              on: {
                                click: function($event) {
                                  return _vm.toggle()
                                }
                              }
                            },
                            [_vm._v("Publicera")]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.status === "Published"
                      ? [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "t-text-style-alpha t-margin-bottom-s"
                            },
                            [_vm._v("Du avpublicerar nu process")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                              on: { click: _vm.toggleStatusModal }
                            },
                            [_vm._v("Avbryt")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "c-button c-button--primary",
                              on: {
                                click: function($event) {
                                  return _vm.toggle()
                                }
                              }
                            },
                            [_vm._v("Avpublicera")]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "process-step"
        ? [
            _vm.status === "Unpublished"
              ? _c("div", { staticClass: "c-visibility__action" }, [
                  _c("p", [
                    _c(
                      "span",
                      {
                        staticClass: "c-icon c-icon--28px",
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("svg", [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-closed-eye" }
                          })
                        ])
                      ]
                    ),
                    _vm._v("\n\t\t\t\t\tSteget är dolt\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-visibility__action" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "c-button c-button--reset c-button--linkstyle",
                        attrs: { type: "submit" },
                        on: { click: _vm.toggleVisibilityModal }
                      },
                      [_vm._v("Publicera steg")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.status === "Published"
              ? _c("div", { staticClass: "c-visibility__action" }, [
                  _c("p", [
                    _c(
                      "span",
                      {
                        staticClass: "c-icon c-icon--28px",
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("svg", [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-open-eye" }
                          })
                        ])
                      ]
                    ),
                    _vm._v("\n\t\t\t\t\tSteget är publicerat\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-visibility__action" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "c-button c-button--reset c-button--linkstyle",
                        attrs: { type: "submit" },
                        on: { click: _vm.toggleVisibilityModal }
                      },
                      [_vm._v("Avpublicera steg")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "modal",
              {
                attrs: { show: _vm.showVisibilityModal },
                on: { closeModal: _vm.toggleVisibilityModal }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "c-modal__content t-background-white t-text-align-center"
                  },
                  [
                    _vm.status === "Unpublished"
                      ? [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "t-text-style-alpha t-margin-bottom-s"
                            },
                            [_vm._v("Du publicerar nu steget")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                              on: { click: _vm.toggleVisibilityModal }
                            },
                            [_vm._v("Avbryt")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "c-button c-button--primary",
                              on: {
                                click: function($event) {
                                  return _vm.toggle()
                                }
                              }
                            },
                            [_vm._v("Publicera")]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.status === "Published"
                      ? [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "t-text-style-alpha t-margin-bottom-s"
                            },
                            [_vm._v("Du avpublicerar nu steget")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                              on: { click: _vm.toggleVisibilityModal }
                            },
                            [_vm._v("Avbryt")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "c-button c-button--primary",
                              on: {
                                click: function($event) {
                                  return _vm.toggle()
                                }
                              }
                            },
                            [_vm._v("Avpublicera")]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }